import { Stack } from '@components/stack';
import { Text } from '@components/text';

import { useFileTranslations } from './locale';

export type FileAcceptTextProps = {
  accept?: string;
  maxFileSizeMb?: number;
};

export const FileAcceptText = ({ accept, maxFileSizeMb }: FileAcceptTextProps) => {
  const { t } = useFileTranslations();
  const extensions = accept ? accept.split(',').filter(Boolean).join(' ') : '';

  if (maxFileSizeMb === undefined && !extensions) return null;

  return (
    <Stack space={0}>
      {maxFileSizeMb !== undefined && (
        <Text font="regular14" color="purple60" text={t('maxFileSize', { size: maxFileSizeMb })} />
      )}
      {extensions && (
        <Text font="regular14" color="purple60" text={`${t('accepted')} ${extensions}`} />
      )}
    </Stack>
  );
};
